import { render, staticRenderFns } from "./ImportResource.vue?vue&type=template&id=006ac356&scoped=true&"
import script from "./ImportResource.vue?vue&type=script&lang=ts&"
export * from "./ImportResource.vue?vue&type=script&lang=ts&"
import style0 from "./ImportResource.vue?vue&type=style&index=0&id=006ac356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ac356",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
